import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DeclaracaoRendEmpFinDetalheComponent } from '../declaracao-rend-emp-fin-detalhe/declaracao-rend-emp-fin-detalhe.component';
import { DeclaracaoRendimentoEmpFinComponent } from '../declaracao-rendimento-emp-fin.component';


const declaracaoRendimentoRoutes = [
    { path: 'declaracaoRedimentosEmpFin/:tipo', component: DeclaracaoRendimentoEmpFinComponent },
    { path: 'declaracaoRendEmpFinDetalheComponent/:tipo', component: DeclaracaoRendEmpFinDetalheComponent }
]

@NgModule({
    imports: [RouterModule.forChild(declaracaoRendimentoRoutes)],
    exports: [RouterModule]
})
export class DeclaracaoRendimentoEmpFinRoutingModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/declaracao-rendimento-emp-fin/router/declaracao-rendimento-emp-fin.router.ts